
import Vue from 'vue'
import vueDropzone from 'vue2-dropzone'
import UiIcon from '@/components/common/UiIcon.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {Component} from 'vue-property-decorator'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {apiUrl} from '@/config/service'
import {namespace} from 'vuex-class'
import {optionsVslim} from '@/config/v-slim-dialog'

const authModule = namespace('auth')
const documentModule = namespace('document')

@Component({
  components: {
    BaseListItemContainer,
    vueDropzone,
    UiIcon
  }
})
export default class MailDocument extends Vue {
  @authModule.Getter('tokenGetter') token: any
  @documentModule.Action('getDocumentsGeneriquesAction') getDocumentsGeneriques: any
  @documentModule.Getter('documentsGeneriquesGetter') documentsGeneriques: any
  @documentModule.Action('downloadDocumentAction') downloadDocument: any
  @documentModule.Action('deleteDocumentAction') deleteDocument: any
  @documentModule.Action('syncDocumentAction') syncDocument: any
  dropzoneOptions = null

  $refs: {
    myVueDropzone: any
  }

  mounted() {
    this.getDocumentsGeneriques()
    this.dropzoneOptions = {
      url: `${apiUrl}/document/upload`,
      headers: {
        Authorization: `Bearer ${this.token}`
      },
      maxFilesize: 30
    }
  }

  getConvertedSize(size) {
    return size !== 0 ? `${Math.round(size / 1000)} Ko -` : null
  }

  getExt(filename) {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2)
  }

  sendFile(file, xhr, formData) {
    formData.append('ID_PROSPECT', 0)
  }

  onComplete(file) {
    this.$refs.myVueDropzone.removeFile(file)
  }

  onQueueComplete() {
    this.getDocumentsGeneriques()
  }

  changeOrder() {
    this.syncDocument(this.documentsGeneriques)
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm('Confirmez vous la suppression du document ?', optionsVslim)
    if (ok) {
      this.deleteDocument(id).then(async () => {
        await this.getDocumentsGeneriques()
      })
    }
  }

  onDownload(item: any) {
    this.downloadDocument(item)
  }

  onError(file, data, xhr) {
    if (data.type === 'validation') {
      Vue.notify({
        group: 'user',
        type: 'warn',
        title: 'Validation des champs',
        text: data.validations.message
      })
    }
  }
}
